import fetch from "../components/Fetchinterceptor/FetchInterceptor";


const consultationService = {}
const apiRoute = '/online-consultation';


consultationService.create = async function (data) {
    try {
      const res = await fetch({
        url: `${apiRoute}/create`,
        method: 'post',
        data: data,
      })
      return res
    } catch (err) {
      console.log(err, 'show-err')
    }
  }



export default consultationService;